/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
import { Box, Button, Tooltip, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ScheduleIcon from "@mui/icons-material/Schedule";
import React, { useEffect, useState } from "react";
import "./admindashboard.css";
import useAxiosPrivate from "contexts/interceptors/axios";
import SubmissionsByOfficeTypeModal from "modals/i-abide/SubmissionsByOfficeTypeModal";
import { useStateContext } from "../../../../../contexts/ContextProvider";
import SubmissionsTable from "../Submissions/SubmissionsTable";

function IABIDEAdminDashboard() {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();
  const [submissionData, setSubmissionData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [submissionCounts, setSubmissionCounts] = useState({});

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllSubmissions`)
      .then((e) => {
        if (auth?.role === "admin") {
          // If admin, set all submissions
          setSubmissionData(e?.data);
        } else if (
          auth?.role === "education program supervisor" ||
          auth?.role === "chief education supervisor" ||
          auth?.role === "accountant 3" ||
          auth?.role === "administrative officer 2" ||
          auth?.role === "administrative officer 4" ||
          auth?.role === "administrative officer 5" ||
          auth?.role === "project development officer 1" ||
          auth?.role === "project development officer 2" ||
          auth?.role === "education program specialist 2" ||
          auth?.role === "senior education program specialist"
        ) {
          // If cid - eps, filter by posted_by
          const filtered = e?.data.filter(
            (submission) => submission.postedBy === auth?.username
          );

          setSubmissionData(filtered);
        } else {
          // For other roles, filter by officeId
          const filtered = e?.data.filter(
            (submission) => submission.relatedOfficeId === auth?.officeId
          );
          setSubmissionData(filtered);
        }
      })
      .catch((err) => {
        setError(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenModal = async (id) => {
    setLoading(true);

    axiosPrivate
      .get(`/I-Abide/getSubmissionsByOfficeType/${id}`)
      .then((res) => {
        setModalData(res?.data);

        setModalOpen(true);
      })
      .catch((err) => {
        console.error("Failed to fetch submissions by location name:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    handleGetAll();
  }, []);

  useEffect(() => {
    if (!selectedSubmission?.length) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedSubmission]);

  const officeTypes = [
    { id: 1, type: "Elementary" },
    { id: 2, type: "Junior High School" },
    { id: 3, type: "Senior High School" },
    { id: 4, type: "Integrated" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#f0f0f0",
        px: 7,
        py: 2,
      }}
    >
      {error}
      {loading}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          width: "100%",
          my: 2,
        }}
      >
        <Box>
          <Typography
            sx={{ textAlign: "left", fontSize: "30px", fontWeight: "bold" }}
          >
            {auth?.role === "admin"
              ? "Welcome to the I-ABIDE Admin Dashboard!"
              : "Welcome to the DepEd Official's Dashboard!"}
          </Typography>
          <Typography
            sx={{ textAlign: "left", fontSize: "20px", fontWeight: "bold" }}
          >
            {auth?.role === "admin" ? "Administrator" : auth?.username}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          my: 5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "10vw",
            alignItems: "center",
          }}
        >
          {officeTypes.map((office) => (
            <Box key={office.id} onClick={() => handleOpenModal(office.id)}>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  "&:hover": {
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)", // Shadow effect on hover
                    transition: "box-shadow 0.2s", // Smooth transition for shadow
                    cursor: "pointer",
                    borderRadius: "50%",
                  },
                }}
              >
                <CircularProgress
                  variant="determinate"
                  value={submissionCounts[office.id] || 0}
                  size={200}
                  thickness={5}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                    sx={{ fontSize: "21px", fontWeight: "bold" }}
                  >
                    {office.type}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            mt: 10,
            mb: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <ScheduleIcon sx={{ fontSize: "36px" }} />
          <Typography
            sx={{ fontFamily: "Poppins", fontSize: 18, fontWeight: "bold" }}
          >
            Recent Submissions
          </Typography>
        </Box>
        <SubmissionsByOfficeTypeModal
          open={modalOpen}
          handleClose={() => handleCloseModal()}
          modalData={modalData}
        />
        <SubmissionsTable
          data={submissionData}
          setSelectedData={setSelectedSubmission}
          loadingState={loading}
          updateTableFunction={handleGetAll}
        />
      </Box>
    </Box>
  );
}

export default IABIDEAdminDashboard;
